import axios from "@/api/index";
let method = 'GET';
/*查询相应状态订单*/
export const getOrdersInfo=data=>axios.post('/order/order/getOrdersInfo',data)
/*订单详情*/
export const getMyOrderDetails=data=>axios.post('/order/myOrderNew/getMyOrderDetails',data)
/*取消订单*/
export const cannalByIdOrders=data=>axios.post('/order/order/cannalByIdOrders',data)
/*删除订单*/
export const deletOrdersById=data=>axios.post('/order/order/deletOrdersById',data)
/*支付识别二维码*/
export const checkPayQrCode=data=>axios.post('/pay/qrCodePay/checkPayQrCode',data)
/*支付获取二维码*/
export const getPayQrCode=data=>axios.post('/pay/qrCodePay/getPayQrCode',data)
/*获取退款原因列表*/
export const getRefundReason=data=>axios.get('/order/refund/applicationForRefund',data)
/*退款申请*/
export const applicationForRefund=data=>axios.post('/order/refund/applicationForRefund',data)
/*取消退款*/
export const cancelRefund=data=>axios.post('/order/refund/cancelRefund',data)
/*买家提醒发货/服务*/
export const buyerReminderShipmentOrService=data=>axios.post('/order/myOrderNew/buyerReminderShipmentOrService',data)
/*评价及追加评价*/
export const evaluateMangement=data=>axios.post('/order/order/evaluateMangement',data)
/*确认完成订单*/
export const confirmCompletedOrder=data=>axios.post('/order/order/confirmCompletedOrder',data)